import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';

import { NavigationItem, NavigationService } from '../../../services/navigation.service';

@Component({
  selector: 'lib-vertical-nav-item',
  standalone: true,
  imports: [
    CommonModule,
    MatListModule,
    MatIconModule,
    MatTooltipModule
  ],
  templateUrl: './vertical-nav-item.component.html',
  styleUrl: './vertical-nav-item.component.scss'
})
export class VerticalNavItemComponent {
  @Input() item!: NavigationItem;
  @Input() isCollapsed = false;
  @Input() level = 0;
  @Input() isHandset = false;

  private navigationService = inject(NavigationService);
  private router = inject(Router);

  onItemClick(item: NavigationItem, event?: Event): void {
    if (item.disabled) return;

    // Stop event propagation to prevent parent clicks
    if (event) {
      event.stopPropagation();
    }

    // If item has children route, navigate directly and expand/collapse
    if (item.children && item.children.length > 0) {
      // On handset, if already expanded and has route, navigate
      if (this.isHandset && item.expanded && item.route) {
        this.navigationService.navigateTo(item.route);
        //return;
      }

      // Otherwise, toggle expansion
      item.expanded = !item.expanded;
      //return;
    }

    // Navigate or execute action for leaf items
    if (item.route) {
      this.navigationService.navigateTo(item.route);
    }

    if (item.action) {
      this.navigationService.executeAction(item.action);
    }

    // Auto-close on mobile after navigation
    // if (this.isHandset) {
    //   this.navigationService.setCollapse(true);
    // }
  }

  isActive(item: NavigationItem): boolean {
    if (item.route) {
      const currentUrl = this.router.url.split('?')[0].split('#')[0];
      if (item.route === '/') {
        return currentUrl === '/';
      }
      return currentUrl === item.route || currentUrl.startsWith(item.route + '/');
    }
    return false;
  }

  hasActiveChild(item: NavigationItem): boolean {
    if (!item.children || item.children.length === 0) return false;
    return item.children.some(child => this.isActive(child) || this.hasActiveChild(child));
  }
}
